import useBreakpoint from '@/hooks/useBreakpoint';
import estaNoContextoHome from '@/utils/verificarCaminhoURL';
import { usePathname } from 'next/navigation';
import { useEffect, useCallback } from 'react';

export const valoresMargemTopoPagina = {
  pagamento: {
    mobile: 64,
    desktop: 80,
  },
  home: {
    mobile: 114,
    desktop: 74,
  },
  padrao: {
    mobile: 60,
    desktop: 60,
  },
};

export const usePageScrollAreaHook = ({
  isPageScrollArea = true,
}: {
  isPageScrollArea?: boolean;
}) => {
  const caminhoURL = usePathname();
  const { breakpoint } = useBreakpoint();

  const calcularMargemTop = useCallback(
    (caminho: string) => {
      if (['/pagamento-cartao', '/pagamento-pix'].includes(caminho)) {
        return valoresMargemTopoPagina.pagamento[breakpoint];
      }

      if (caminho.includes('refazer-pedido')) {
        return valoresMargemTopoPagina.padrao[breakpoint];
      }

      if (
        caminho.includes('/cadastrar-novo-cartao') &&
        breakpoint === 'mobile'
      ) {
        return valoresMargemTopoPagina.pagamento[breakpoint];
      }

      if (
        !caminho.includes('/customizar-plano') &&
        estaNoContextoHome(caminho)
      ) {
        return valoresMargemTopoPagina.home[breakpoint];
      }

      return valoresMargemTopoPagina.padrao[breakpoint];
    },
    [breakpoint],
  );

  useEffect(() => {
    if (!isPageScrollArea) return;
    if (
      typeof document !== 'undefined' &&
      !caminhoURL.includes('minhas-compras')
    ) {
      const margemTopo = calcularMargemTop(caminhoURL);
      document.body.scrollTo({
        top: -margemTopo,
        behavior: 'smooth',
      });
    }
  }, [caminhoURL, isPageScrollArea, calcularMargemTop]);

  const retornarValorMargemTopo = useCallback(
    (local: keyof typeof valoresMargemTopoPagina) => {
      return valoresMargemTopoPagina[local][breakpoint];
    },
    [breakpoint],
  );

  return { calcularMargemTop, retornarValorMargemTopo };
};
